import React from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Typography,
  IconButton,
} from '@mui/material';
import PublicIcon from '@mui/icons-material/Public';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import LinkIcon from '@mui/icons-material/Link'; // Importing a new icon for URL Generator
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from 'react-router-dom';
import DynamicBreadcrumbs from '../Shared/Breadcrumb/index.tsx';
import MenuBookIcon from '@mui/icons-material/MenuBook'; 
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

type CardInfo = {
  title: string;
  route: string;
  icon: React.ReactElement;
  description: string;
};

const cards: CardInfo[] = [
  // {
  //   title: 'Web Scrapping',
  //   route: '/r/tools/web-scrap',
  //   icon: <PublicIcon fontSize="large" color="primary" />,
  //   description: 'Web Scrapper tool kit is used to scrape websites.',
  // },
  // {
  //   title: 'PDF Scrapping',
  //   route: '/r/tools/pdf-scrap',
  //   icon: <PictureAsPdfIcon fontSize="large" color="error" />,
  //   description: 'Extract data from PDF documents with ease.',
  // },
  // {
  //   title: 'Video Scrapping',
  //   route: '/r/tools/video-scrap',
  //   icon: <VideoLibraryIcon fontSize="large" color="success" />,
  //   description: 'Pull metadata or content from video files or platforms.',
  // },
  {
    title: 'URL Generator',
    route: '/r/tools/url-generator',
    icon: <LinkIcon fontSize="large" color="info" />,
    description: 'Generate structured URLs quickly and easily.',
  },
  {
    title: 'Audio to Text',
    route: '/r/tools/audio-transcribe',
    icon: <VideoLibraryIcon fontSize="large" color="warning" />,
    description: 'Convert spoken audio into written text quickly.',
  },
  {
    title: 'Instruction Set',
    route: '/r/tools/instruction-set',
    icon: <MenuBookIcon fontSize="large" color="secondary" />,
    description: 'Create, manage, and organize step-by-step instructions or task flows.',
  },
  {
    title: 'Dynamic Chatbot',
    route: '/r/tools/dynamic-chatbot',
    icon: <SupportAgentIcon fontSize="large" color="primary" />,
    description: '“Enter your domain → Get embed script → Paste in your HTML → Start chatting!”',
  },
];

const Index = () => {
  const navigate = useNavigate();

  const breadcrumbsData = [
    {
      label: (
        <IconButton color="primary">
          <HomeIcon />
        </IconButton>
      ),
      onClick: () => navigate('/'),
    },
    { label: 'Tools' },
  ];

  return (
    <Box sx={{ padding: 2, backgroundColor: '#f4f6f8', borderRadius: 2 }}>
      <DynamicBreadcrumbs
        items={breadcrumbsData}
        onBreadcrumbClick={(e, item) => item?.onClick?.()}
      />

      <Grid container spacing={3} justifyContent="center" sx={{ mt: 4 }}>
        {cards.map((card, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              elevation={3}
              sx={{
                borderRadius: 3,
                transition: 'transform 0.2s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.03)',
                },
              }}
            >
              <CardActionArea onClick={() => navigate(card.route)}>
                <CardContent sx={{ textAlign: 'center' }}>
                  <Box display="flex" justifyContent="center" mb={1}>
                    {card.icon}
                  </Box>
                  <Typography variant="h6" fontWeight="bold">
                    {card.title}
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    {card.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Index;
